/* eslint-disable */
import Vue from 'vue';
import confirm from '@/components/confirm.vue';

const confirmConstructor = Vue.extend(confirm);

const theConfirm = function (text, page) {
  return new Promise((res, rej) => { // promise封装，ok执行resolve，no执行rejectlet
    const confirmDom = new confirmConstructor({
      el: document.createElement('div'),
    });
    document.body.appendChild(confirmDom.$el); // new一个对象，然后插入body里面

    confirmDom.obj = text; // 为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
    confirmDom.obj.class = page || '';// 传class
    confirmDom.ok = function () {
      res();
      confirmDom.isShow = false;
    };
    confirmDom.no = function () {
      rej();
      confirmDom.isShow = false;
    };
  });
};

export default theConfirm;

// 在需要的地方直接用以下方法调用即可：
// import confirm from '@/utils/confirm';
// confirm({
//     title: '提示',
//     text: '是否删除这条信息？',
//     dangerouslyUseHTMLString: false, //内容是否是html
//     btn: {
//         ok: '确定',
//         no: '取消'
//     }
// }).then(() => {
//     console.log('确定')
// })
// .catch(() => {
//     console.log('取消')
// })
